import {Component, EventEmitter, Input, Output} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'fb-product-tabs',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './product-tabs.component.html',
	styleUrls: ['./product-tabs.component.scss']
})
export class ProductTabsComponent {

	@Input()
	public activeTab: string = 'customization';

	@Output()
	public tabChange = new EventEmitter<string>();
	@Input()
	public showCustomizationTab: boolean = true;

	public setActiveTab(tab: string): void {
		this.activeTab = tab;
		this.tabChange.emit(tab);
	}
}
